import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Info',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Info',
        href: '/adm/info',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_info',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'info_code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'title',
        label: 'Title',
        sortable: true,
      },
      {
        key: 'desc',
        label: 'Desc',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'status_info',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeInfo(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchInfo(context, params = null) {
    let result = await ApiGetRequest(`info`, params);
    return !result.error ? result.data.object : [];
  },

  async getListInfo({ commit, state }) {
    commit('changeInfo', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`info`, params);
    commit('changeInfo', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailInfo({ commit }, payload = null) {
    commit('changeInfo', {
      loading: true,
    });

    let result = await ApiGetRequest(`info/${payload.id}`);
    commit('changeInfo', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadImageInfo({ commit, state }, payload) {
    commit('changeInfo', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeInfo', {
      loading: false,
    });

    if (!result.error) {
      commit('changeInfo', {
        form: {
          ...data.form,
          img_info: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeInfo', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`info/import`, {
      items: data.import_form || [],
    });

    commit('changeInfo', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createInfo({ commit, state, dispatch }) {
    commit('changeInfo', {
      loading: true,
    });

    let result = await ApiPostRequest(`info`, state.data.form);
    commit('changeInfo', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateInfo({ commit, state, dispatch }, payload = null) {
    commit('changeInfo', {
      loading: true,
    });

    let result = await ApiPutRequest(`info/${payload.id}`, state.data.form);

    commit('changeInfo', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteInfo({ commit, dispatch }, payload = null) {
    commit('changeInfo', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`info/${payload.id}`);
    commit('changeInfo', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
